var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalClientsDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#8B4500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13135 21.5576H17.4992M17.4992 21.5576V13.3948C18.098 13.6008 19.5094 13.9563 20.1812 14.2499C20.8733 14.5524 21.0752 15.4055 21.0752 16.213V21.5576M17.4992 21.5576H21.0752M21.8691 21.5576H21.0752",
    stroke: "#FFB348",
    strokeWidth: 1.0435,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7876 21.0702V11.3367C8.7876 9.65775 8.7876 8.8176 9.3167 8.40087C9.84581 7.98414 10.6251 8.2109 12.1843 8.66308L15.5289 9.63367C16.4693 9.90658 16.9396 10.043 17.2111 10.4156C17.4834 10.7875 17.4834 11.2939 17.4834 12.308V21.0702",
    stroke: "#FFB348",
    strokeWidth: 1.00336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1323 12.8638H14.139M12.1323 15.5394H14.139M14.8079 21.4748V19.5529C14.8079 18.922 14.8079 18.607 14.6119 18.411C14.4159 18.215 14.1009 18.215 13.4701 18.215H12.8012C12.1704 18.215 11.8554 18.215 11.6594 18.411C11.4634 18.607 11.4634 18.922 11.4634 19.5529V21.4953",
    stroke: "#FFB348",
    strokeWidth: 1.00336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalClientsDark);
export default __webpack_public_path__ + "static/media/Total_Clients_Dark.26daa948b5df5808269de15400365c24.svg";
export { ForwardRef as ReactComponent };